<template>
  <div class="checkBox">
    <div class="checkBox-group">
      <div class="allCheck">
        <div @click="allChange" class="box">
          <img src="@/assets/reservation/cb_on.png" alt="" v-if="checkAll" />
          <img src="@/assets/reservation/cb.png" alt="" v-else />ข้อตกลงฉบับเต็ม (อ่านและยอมรับข้อตกลงทั้งหมด)
        </div>
        <div class="tag" @click="showDialog">
          <img
            :src="require('@/assets/reservation/protocol_button.png') "
            alt=""
          />
        </div>
      </div>
      <div class="check">
        <div
          class="checkbox-item"
          @click="itemClick(item, index)"
          v-for="(item, index) in checkBoxData"
          :key="index"
        >
          <img src="@/assets/reservation/cb.png" alt="" v-if="!item.checked" />
          <img src="@/assets/reservation/cb_on.png" alt="" v-else />
          <span v-text="item.name"></span>
        </div>
      </div>
    </div>
    <div class="agreement" ref="agreement" v-if="visible">
      <div class="agreement-wrapper">
        <img src="@/assets/reservation/protocol.webp" alt="" />
        <div class="close" @click="close"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checkBoxData: [
        {
          value: 0,
          name: "ข้อตกลงในการรวบรวมและใช้ข้อมูลส่วนบุคคล (จำเป็น) ",
          checked: false,
        },
        { value: 1, name: "ยินยอมให้ส่งข้อความส่วนบุคคล (จำเป็น)", checked: false },
      ],
      visible: false,
      checkAll: false,
      clientWidth: document.body.clientWidth,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    document.addEventListener("mouseup", (e) => {
      let agreement = this.$refs.agreement;
      if (agreement) {
        if (!agreement.contains(e.target)) {
          this.visible = false;
        }
      }
    });
  },
  methods: {
    handleResize() {
      this.clientWidth = document.body.clientWidth;
    },
    close() {
      this.visible = false;
    },
    itemClick(item) {
      item.checked = !item.checked;
      let all = true;
      let data = [];
      this.checkBoxData.forEach((item) => {
        if (!item.checked) {
          all = false;
        } else {
          data.push(item.value);
          this.$emit("getCheckVal", data);
        }
      });
      this.checkAll = all;
    },
    showDialog() {
      this.visible = true;
    },
    allChange() {
      this.checkAll = !this.checkAll;
      this.checkBoxData.forEach((item) => {
        if (this.checkAll) {
          item.checked = true;
          this.$emit("getCheckVal", [0, 1]);
        } else {
          item.checked = false;
          this.$emit("getCheckVal", []);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.checkBox {
  width: 100%;
  font-size: 20px;
  color: #fff;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
 
  @media only screen and (max-width: 1024px) {
    font-size: 12px;
  }
  .agreement {
    position: absolute;
    top: -30%;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
    z-index: 999;
    &-wrapper {
      width: 100%;
      height: 100%;
      position: relative;
      img {
        width: 100%;
        margin-right: 0;
        height: auto;
        @media only screen and (max-width: 1024px) {
          width: 80vw;
        }
      }
      .close {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        z-index: 9;
        width: 74px;
        height: 74px;
        @media only screen and (max-width: 1024px) {
          width: 10px;
          height: 10px;
          right: 5%;
          top: 0.5%;
        }
        img {
          width: auto;
          @media only screen and (max-width: 1024px) {
            width: 100%;
          }
        }
      }
    }
  }
  .checkBox-group {
    width: 100%;
    .allCheck {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      @media only screen and (max-width: 1024px) {
        // flex-direction: column;
        grid-gap: 10px;
        align-items: flex-start;
      }
      @media only screen and (max-width: 768px) {
        flex-direction: column;
      }
      .box {
        display: flex;
        align-items: center;
        text-align: left;
        font-size: 2rem;
        img{
           width: 3.1rem;
           height: 3.1rem;
        }
        @media only screen and (max-width: 1800px) {
            font-size: 1.5rem;
        }
        @media only screen and (max-width: 1400px) {
           img{
             width: 2rem;
             height: 2rem;
          }
        }
        @media only screen and (max-width: 768px) {
          img{
            flex-shrink: 1;
          }
        } 
      }
      .tag {
        margin-left: 52px;
        @media only screen and (max-width: 1024px) {
          margin: 0;
        }
        img {
          width: auto;
          height: 3.5rem;
         
          // @media only screen and (max-width: 1024px) {
          //   width: 40%;
          // }
        }
      }
    }
    .check {
      display: flex;
      align-items: center;
      grid-gap: 20px;
      @media only screen and (max-width: 1024px) {
        grid-gap: 0px;
        flex-wrap: wrap;
      }
      .checkbox-item {
        display: flex;
        align-items: center;
        margin-bottom: 57px;
        font-size: 2rem;
        text-align: left;
        white-space: nowrap;
        img{
            width: 3.1rem;
            height: 3.1rem;
       }
     @media only screen and (max-width: 1400px) {
       white-space: pre-wrap;
        img{
          height:2rem;
          width: 2rem;
        }
      }
         @media only screen and (max-width: 1800px) {
           font-size: 1.5rem;
         }
      }
       @media only screen and (max-width: 1200px) {
          .checkbox-item {
            margin-bottom: 15px;
            text-align: left;
            align-items: flex-start;
            &:last-child{
              margin-bottom: 0;
            }
          }
       }
    
    }
  }
  .submit_btn {
    width: 280px;
    cursor: pointer;
    img {
      width: 100%;
      height: auto;
    }
  }
}
img {
  width: 25px;
  height: 25px;
  margin-right: 24px;
  cursor: pointer;
  @media only screen and (max-width: 1024px) {
    width: 15px;
    height: 15px;
    margin-right: 12px;
  }
}
</style>
